import {
  ArrowLeft01Icon,
  ArrowRight01Icon,
  Cancel01Icon,
  TickDouble01Icon
} from '@hugeicons/react'

import { Button } from '@/shared/ui/Button'

export const GuideTourTooltip = ({
  continuous,
  index,
  isLastStep,
  size,
  step,
  backProps,
  closeProps,
  primaryProps,
  tooltipProps
}) => (
  <div className="max-w-full w-[350px] bg-white rounded-xl border border-gray-200 shadow-md overflow-hidden" {...tooltipProps}>
    <div className="p-5 text-base">
      {step.title && (
        <span className="text-3xl font-bold block mb-4">{step.title}</span>
      )}
      {step.content}
    </div>
    <div className="flex justify-center px-5 pb-4">
      {index > 0 && (
        <div className="mr-auto">
          <Button variant="ghost" size="sm" showTrailingIcon={false} leadingIcon={<ArrowLeft01Icon variant="duotone" size={14} />} {...backProps}>
            Anterior
          </Button>
        </div>
      )}
      {index === 0 && step?.initButton ? (
        <Button variant="primary" size="sm" showTrailingIcon={false} {...primaryProps}>
          {step?.initButtonText || 'Iniciar'}
        </Button>
      ) : (
        <>
          {continuous && (
            <Button
              variant={isLastStep ? 'success' : 'primary'}
              size="sm"
              showTrailingIcon={false}
              trailingIcon={
                isLastStep
                  ? <TickDouble01Icon variant="duotone" size={14} />
                  : <ArrowRight01Icon variant="duotone" size={14} />
              }
              {...primaryProps}
            >
              {isLastStep ? 'Finalizar' : 'Próximo'}
            </Button>
          )}
          {!continuous && (
            <Button variant="danger" size="sm" showTrailingIcon={false} leadingIcon={<Cancel01Icon variant="duotone" size={14} />} {...closeProps}>
              Fechar
            </Button>
          )}
        </>
      )}
    </div>
  </div>
)
